import { call, put, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { 
  REQUEST, 
  editSegmentSuccess, 
  editSegmentFailure 
} from '../../actions/segments/edit';
import { fetchRequest as fetchSegments } from '../../actions/segments/list';
import { fetchRequest as fetchSegmentDetail } from '../../actions/segments/detail';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error as ErrorAction } from '../../actions/error/error';

// Worker saga for editing a segment
function* editSegment(action) {
  try {
    // Get headers from the utility function
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    // Add content type header
    headers['Content-Type'] = 'application/json';
    
    const response = yield call(axios.put, 
      `${config.API_URL}/segment/${action.segmentId}`,
      action.payload,
      { headers }
    );
    
    // Dispatch success action with the response data
    yield put(editSegmentSuccess(response.data));
    
    // Add success snackbar message
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Segment updated successfully' });
    
    // Add a short delay to ensure the UI has time to process the success
    yield delay(300);
    
    // Refresh the segments list after successful edit
    yield put(fetchSegments({}));
    
    // Also refresh the segment detail if applicable
    if (action.segmentId) {
      yield put(fetchSegmentDetail(action.segmentId));
    }
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Edit segment saga error:', error);

    const errorMessage = error?.response?.status === 404
      ? `Segment with ID ${action.segmentId} could not be found or endpoint doesn't exist`
      : extractErrorMessage(error);

    yield put(ErrorAction(error));
    yield put(editSegmentFailure(errorMessage));
    
    return {
      success: false,
      error: errorMessage
    };
  }
}

// Watcher saga for segment editing
export function* watch() {
  yield takeLatest(REQUEST, editSegment);
} 